import React, { Component } from "react";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import * as Constants from "../Constants/index";
import axios from "axios";
import Text from "react-text";
import DatePicker from "react-datepicker";
import Select from "react-select";
import ReCAPTCHA from "react-google-recaptcha";
import LiveChat from "../components/livechat/livechat.component";




const style = {
  control: (base) => ({
    ...base,
    border: 0,
    boxShadow: "none",
  }),
};



class Contact extends Component {
  constructor(props) {
    super(props);

    this.state = {
      cinemas: [],
      selectedDate: null,
      selectedOptionOne: '',
      selectedOptionTwo: '',
      selectedOptionThree: '',
      selectedOptionFour: '',
      text: '',
      isCaptchaVerified: false,

    };


    this.handleChange = this.handleChange.bind(this)
  }

  handleCaptchaChange = (value) => {
    // The callback when the user solves the CAPTCHA
    this.setState({ isCaptchaVerified: true });
  }


  handleChange(value) {
    this.setState({ text: value });
  }

  handleDateChange = (date) => {
    this.setState({
      selectedDate: date,
    });
  };






  componentDidMount() {
    if (this.props.hideLocations) {
      return;
    }

    const token = localStorage.getItem("token");

    axios
      .get(Constants.api + "content/cinemas", "", {
        headers: {
          "Accept-Language": localStorage.getItem("language"),
          Authorization: `Bearer ${token}`,
          appversion: Constants.av,
          platform: window.matchMedia('(max-width: 575px)').matches ? "MSITE" : "WEBSITE",
        },
      })
      .then((res) => {
        console.log("cinesdasdsadasdmas");
        console.log(res);
        
        this.setState({
          cinemas: res.data.output.cinemas,
        });
      });
  }
  handleSelectChangeOne = (selectedOption1) => {
    this.setState({ selectedOptionOne: selectedOption1 });
  }
  handleSelectChangeTwo = (selectedOption2) => {
    this.setState({ selectedOptionTwo: selectedOption2 });
  }
  handleSelectChangeThree = (selectedOption3) => {
    this.setState({ selectedOptionThree: selectedOption3 });
  }
  handleSelectChangeFour = (selectedOption4) => {
    this.setState({ selectedOptionFour: selectedOption4 });
  }
  render() {
    if (this.props.language && localStorage.getItem("language") !== this.props.language) {
      localStorage.setItem("language", this.props.language);
    }
    const isArabic = (this.props.language || localStorage.getItem("language")) === "ar";

    const { selectedOptionOne } = this.state;
    const { selectedOptionTwo } = this.state;
    const { selectedOptionThree } = this.state;
    const { selectedOptionFour } = this.state;


    const optionsOne = [
      { value: "option1", label: "Option 1" },

      { value: "option2", label: "Option 2" },

      { value: "option3", label: "Option 3" },

    ];




    const openmap = (lat, long) => {
      console.log(lat);
      console.log(long);
      console.log('map page');
      let map =
        "https://www.google.com/maps/embed/v1/place?key=AIzaSyAgURva0yoMANv5oC9zAsn_bCMuZGLlSFc&q=" +
        lat +
        "," +
        long;
      this.setState({ mapurl: map, showmap: true });
      window.open(map, "_blank");
    };
    return (
      <div className={`contact-page${isArabic ? " contact-page--rtl" : ""}${this.props.hideLocations ? " contact-page--app" : ""}`}>
        {/* The apps' contact page (/app/contactus) follows the engine's
            chat.apps.enabled; the website's follows chat.website.enabled.
            The store apps up to 17.2 show that page in a small web view,
            where Pair's chat opened squashed over the page. */}
        <LiveChat surface={this.props.hideLocations ? "apps" : "website"} />
        <div className="faq-banner seat-banner">
          <img src={new URL("../assets/my-account.png", import.meta.url).href} alt="" />
          <h3>
            {" "}
            {localStorage.getItem("language") !== "ar" ? (
              "Contact Us"
            ) : (
              <Text>تواصل معنا
              </Text>
            )}
          </h3>
        </div>
        <div class="black-width"></div>
        <div className="faqs-container padbothvertical-40">
          <div class="home-content-containers">
            <div className="get-in-touch">
              <h1>
                {" "}
                {localStorage.getItem("language") !== "ar" ? (
                  "GET IN TOUCH "
                ) : (
                  <Text>وسائل التواصل
                  </Text>
                )}
              </h1>
              <div class="get-head">
                <div className="address">
                  <div className="address-icon">
                    <img
                      src={new URL("../assets/Address.png", import.meta.url).href}
                      className="all-icon"
                      alt="Address"
                    />
                  </div>
                  <div className="address-content">
                    <h2>
                      {" "}
                      {localStorage.getItem("language") !== "ar" ? (
                        "Address"
                      ) : (
                        <Text>عنوان المكتب الرئيسي
                        </Text>
                      )}
                    </h2>
                    <p>
                      {" "}
                      {localStorage.getItem("language") !== "ar" ? (
                        "Khaitan,  Airport Road,  Sama Khaitan Mall, 2nd floor, P.O Box 502 Safat 13006 Kuwait."
                      ) : (
                        <Text>خيطان – طريق المطار – مول سما خيطان – الدور الثاني – ص . ب 502 الصفاة – رمز بريدي 13006 الكويت
                        </Text>
                      )}
                    </p>
                  </div>
                </div>
                <div className="address">
                  <div className="address-icon">
                    <img
                      src={new URL("../assets/Chat.png", import.meta.url).href}
                      className="all-icon"
                      alt="Chat"
                    />
                  </div>
                  <div className="address-content">
                    <h2>
                      {" "}
                      {localStorage.getItem("language") !== "ar" ? (
                        "Chat with us on"
                      ) : (
                        <Text>دردش معنا على</Text>
                      )}
                    </h2>
                    <a href="https://api.whatsapp.com/send?phone=9651803456" target="_blank">
                      <img
                        src={new URL("../assets/Whatsapp.png", import.meta.url).href}
                        className="all-icon"
                        alt="Whatsapp"
                      />{" "}
                      <span className="whats">
                        {" "}
                        {localStorage.getItem("language") !== "ar" ? (
                          "Whatsapp"
                        ) : (
                          <Text>واتس اب</Text>
                        )}
                      </span>
                    </a>
                  </div>
                </div>
                <div className="address">
                  <div className="address-icon">
                    <img
                      src={new URL("../assets/Call_Center.png", import.meta.url).href}
                      className="all-icon"
                      alt="Call Center"
                    />
                  </div>
                  <div className="address-content">
                    <h2>
                      {" "}
                      {localStorage.getItem("language") !== "ar" ? (
                        "Call Centere"
                      ) : (
                        <Text>مركز خدمة العملاء
                        </Text>
                      )}
                    </h2>
                    <p>
                      {" "}
                      {localStorage.getItem("language") !== "ar" ? (
                        "+965 1803456"
                      ) : (
                        <Text>+965 1803456</Text>
                      )}
                    </p>
                  </div>
                </div>
                <div className="address">
                  <div className="address-icon">
                    <img
                      src={new URL("../assets/Mail Icon.png", import.meta.url).href}
                      className="all-icon"
                      alt="Mail"
                    />
                  </div>
                  <div className="address-content address-info">
                    <h2>
                      {" "}
                      {localStorage.getItem("language") !== "ar" ? (
                        "Mail"
                      ) : (
                        <Text>البريد الإلكتروني</Text>
                      )}
                    </h2>
                    <a className="contact-email" href="mailto:feedback@kncc.com">
                      feedback@kncc.com
                    </a>
                  </div>
                </div>
                <div className="address">
                  <div className="address-icon">
                    <img
                      src={new URL("../assets/Social.png", import.meta.url).href}
                      className="all-icon"
                      alt="Phone"
                    />
                  </div>
                  <div className="address-content">
                    <h2>
                      {" "}
                      {localStorage.getItem("language") !== "ar" ? (
                        "Social Media"
                      ) : (
                        <Text>وسائل التواصل الاجتماعي</Text>
                      )}
                    </h2>
                    <div class="social-icons">
                      <a href="https://www.facebook.com/CinescapeKuwait" target="_blank">
                        <img
                          src={new URL("../assets/Facebook.png", import.meta.url).href}
                          className="all-icon"
                          alt="Phone"
                        />
                      </a>
                      <a href="https://twitter.com/Cinescapekuwait" target="_blank">
                        <img
                          src={new URL("../assets/twitterimg.png", import.meta.url).href}
                          className="all-icon"
                          alt="Phone"
                        />
                      </a>
                      <a href="https://www.instagram.com/cinescapekuwait/" target="_blank">
                        <img
                          src={new URL("../assets/Instagram.png", import.meta.url).href}
                          className="all-icon"
                          alt="Phone"
                        />
                      </a>
                      <a href="https://www.youtube.com/@CinescapeKuwait" target="_blank">
                        <img
                          src={new URL("../assets/Youtube.png", import.meta.url).href}
                          className="all-icon"
                          alt="Phone"
                        />
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="contact-container whatsapp-support-section">
          <div className="home-content-containers">
            <div className="whatsapp-support">
              <div className="whatsapp-support-copy">
                <h1>
                  {localStorage.getItem("language") !== "ar" ? "INQUIRE, FEEDBACK, OR SUPPORT" : <Text>للاستفسار أو تقديم الملاحظات أو طلب الدعم،</Text>}
                </h1>
                <h2>
                  {localStorage.getItem("language") !== "ar" ? "Chat with Cinescape on WhatsApp" : <Text>تواصل مع سينسكيب عبر الواتساب</Text>}
                </h2>
                <p>
                  {localStorage.getItem("language") !== "ar" ? (
                    "Whether you need info on movies, Cinescape locations and services, have a quick suggestion to improve your next cinema visit or a complaint that needs immediate attention, our dedicated WhatsApp channel makes reaching us seamless and instant."
                  ) : (
                    <Text>سواء كنت بحاجة إلى معلومات عن الأفلام، أو مواقع سينسكيب وخدماتها، أو كان لديك اقتراح لتحسين زيارتك القادمة للسينما، أو شكوى تحتاج إلى اهتمام فوري، فإن قناة الواتساب المخصصة لدينا تتيح لك التواصل معنا بسهولة وسرعة.</Text>
                  )}
                </p>
              </div>
              <a className="whatsapp-support-link" href="https://api.whatsapp.com/send?phone=9651803456" target="_blank" rel="noopener noreferrer" aria-label="Chat with Cinescape on WhatsApp">
                <strong className={localStorage.getItem("language") === "ar" ? "arabic-chat-now" : ""}>{localStorage.getItem("language") !== "ar" ? "Chat now" : "تحدث معنا الآن"}</strong>
                <span className="whatsapp-pair-brand">
                  <img src={new URL("../assets/Whatsapp.png", import.meta.url).href} alt="" />
                  <span>
                    <span className="whatsapp-name">WhatsApp</span>
                    <small>powered by Pair</small>
                  </span>
                </span>
              </a>
            </div>
          </div>
        </div>

        {/* <section className="location-section padbothvertical-40">
        <div className="home-content-containers">
                  <div className="main-head justify-flex">
                     <h3>
                        {localStorage.getItem("language") !== "ar" ? (
                           "cinescape locations"
                        ) : (
                           <Text>مواقع سينسكيب</Text>
                        )}
                     </h3>
                     <div className="view-all">
                        <a href="/cinelocation">
                           {localStorage.getItem("language") !== "ar" ? (
                              "view all locations"
                           ) : (
                              <Text>عرض كل المواقع</Text>
                           )}
                        </a>
                     </div>
                  </div>
                  <div className="location-container justify-flex-2">
                     {this.state.cinemas.map(function (item, i) {
                        let url = "/cinemasessions/" + item.id
                        return (

                           <>
                              <div className="location-preview">
                                 <div className="location-preview-img">
                                    <a href={url}>   <img src={item.webThumbImageUrl} /></a>
                                 </div>
                                 <div className="location-details">
                                    <p>{item.city}</p>
                                    <p>{item.name}</p>
                                 </div>
                              </div>

                           </>
                        );
                     })}
                  </div>
                  <div className="view-all view-all-mobile">
                     <a href="/cinelocation">
                        {localStorage.getItem("language") !== "ar" ? (
                           "VIEW ALL LOCATIONS"
                        ) : (
                           <Text>مشاهدة الكل</Text>
                        )}
                     </a>
                  </div>
                  </div>
        </section> */}
        {!this.props.hideLocations && <div className="home-content-containers">
          <div className="our-location">
            <h1>
              {" "}
              {localStorage.getItem("language") !== "ar" ? (
                "OUR LOCATIONS"
              ) : (
                <Text>مواقعنا</Text>
              )}
            </h1>
            <div className="cinescap_info">
              {this.state.cinemas.map(function (item, i) {
                let url = "/cinemasessions/" + item.id;
                return (
                  <>
                    <div className="cinescap_location">
                      <div className="flim_info">
                        <a href={url}>
                          {" "}
                          <img
                            src={item.webThumbImageUrl}
                            alt="img"
                            className="contact-locations"
                          />
                        </a>
                        <div className="house_text">
                          <h3>{item.name}</h3>
                          <div className="location_info">
                            <h4>
                              {" "}
                              {localStorage.getItem("language") !== "ar" ? (
                                "Location"
                              ) : (
                                <Text>موقع</Text>
                              )}
                            </h4>
                            <p>{item.city} </p>
                            <p
                              className="map"
                              onClick={() =>
                                openmap(item.latitude, item.longitude)
                              }
                            >
                              <div className="img-map">
                                <img
                                  src={
                                    new URL("../assets/location.png", import.meta.url).href
                                  }
                                />
                              </div>
                              <div className="text-map">
                                {" "}
                                {localStorage.getItem("language") !== "ar" ? (
                                  "Maps"
                                ) : (
                                  <Text>خرائط</Text>
                                )}
                              </div>
                            </p>
                          </div>

                          <div className="cinescap_imgs">
                            <div className="cinescap_img-logo">
                              <img
                                src={
                                  new URL("../assets/Standard Normal@3x.png", import.meta.url).href
                                }
                                alt="img"
                              />
                            </div>
                            <div className="cinescap_img-logo">
                              <img
                                src={new URL("../assets/VIP Normal@3x.png", import.meta.url).href}
                                alt="img"
                              />
                            </div>
                            <div className="cinescap_img-logo">
                              <img
                                src={
                                  new URL("../assets/Premium Normal@3x.png", import.meta.url).href
                                }
                                alt="img"
                              />
                            </div>
                            <div className="cinescap_img-logo">
                              <img
                                src={new URL("../assets/Dolby Cinema Normal@3x.png", import.meta.url).href}
                                alt="img"
                              />
                            </div>
                            <div className="cinescap_img-logo">
                              <img
                                src={new URL("../assets/IMAX Normal@3x.png", import.meta.url).href}
                                alt="img"
                              />
                            </div>
                            <div className="cinescap_img-logo">
                              <img
                                src={new URL("../assets/4DX Normal@3x.png", import.meta.url).href}
                                alt="img"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                );
              })}
            </div>
          </div>
        </div>}
      </div>
    );
  }
}
export default Contact;
